<div class="_header-desktop-component">
	<img class="_header-logo" src="./assets/BEEGO_logo.png" />
    <div class="_header-profile">
		<div class="_picture-container">
			<img *ngIf="profilePicture" class="_profile-picture" [src]="profilePicture" />
		</div>
        <p *ngIf="username" [translate]="'HEADER.INTRO'" [translateParams]="{value: username}"></p>
    </div>
</div>